var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      attrs: {
        "data-app-ver": _vm.meta.version,
        "data-app-env": _vm.meta.env,
        "data-app-buildtimestamp": _vm.meta.buildTimestamp
      }
    },
    [
      _c("router-view"),
      _vm.meta.env !== "p"
        ? _c(
            "div",
            {
              attrs: {
                id: "env-strip",
                "data-app-ver": _vm.meta.version,
                "data-app-env": _vm.meta.env,
                "data-app-buildtimestamp": _vm.meta.buildTimestamp
              }
            },
            [
              _vm._v(
                " v" +
                  _vm._s(_vm.meta.version) +
                  " [" +
                  _vm._s(_vm.meta.env.toUpperCase()) +
                  "]: " +
                  _vm._s(_vm.meta.buildTimestamp) +
                  " "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }